import * as React from "react";
import styled from "styled-components";
import { Icon } from "office-ui-fabric-react";


interface Props{
    pages: number;
    currentPage: number;
    updatePagination: (step: number) => void;
}

const PaginateStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    i{
        cursor: pointer;
        user-select: none;
        color: white;
        padding: 5px;
        background: #0179D4;
    }
    ul{
        padding: 0;
        display: flex;
        list-style: none;
        li{
            cursor: pointer;
            user-select: none;
            padding: 4px 10px;
            padding-bottom: 3px;
            margin: 0px 1px;            
            &.active{
                background: #0179D4;            
                color: white;
            }
            min-width: 40px;
            box-sizing: border-box;
            text-align: center;
        }
    }
`;

const LiSelectStyle = styled.li`
    padding: 0 !important;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    min-width: 20px !important;
    > select{
        opacity: 0;
        padding: 4px 4px;
        margin: 0px 1px;
        padding-right: 0;
        border: none;
        background: transparent;
        -moz-appearance: none;
        -webkit-appearance: none;
        width: 56px;
        cursor: pointer;
        position: absolute;
        left: 0;
    }
    &:hover{
        > i{
            opacity: 1;
        }
    }
    > i{
        padding: 0;
        background: none;
        color: black;
        font-size: 8px;
        position: absolute;
        top: 4px;
        right: 7px;
        pointer-events: none;
        opacity: 0;
    }

    &:before{
        content: "....";
        position: absolute;
        pointer-events: none;
        width: 100%;
        text-align: center;
        height: 100%;
        margin-top: 8px;
        left: 0;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 1px;
    }
`;

const Paginate: React.FunctionComponent<Props> = props =>
{
    const [paginate, updatePaginate] = React.useState(0);
    const pages:number = props.pages;    

    const setPagination = (dir: string, page?: number) => () => 
    {
        switch (dir)
        {
            case "next":
                if (paginate < pages - 1)
                {
                    updatePaginate(paginate + 1);
                    props.updatePagination(paginate + 1);
                }
                break;
            case "prev":
                if (paginate > 0)
                {
                    updatePaginate(paginate - 1);
                    props.updatePagination(paginate - 1);
                }
                break;
            case "go":
                    page ? updatePaginate(page) : updatePaginate(0);
                    page ? props.updatePagination(page) : props.updatePagination(0);    
                break;
                
        }
    };

    const getPages = () =>
    {
        const menuItems = [];
        for (let i = 0; i < pages ; i++)
        {
            menuItems.push(getItem(i));
        }
        return menuItems;
    };

    const getItem = (itemId: number) =>
    {
        return <li key={itemId} className={`${itemId === paginate ? "active" : ""}`} onClick={setPagination("go", itemId)}>{itemId + 1}</li>;
    };

    const getOption = (length: number) =>
    {
        const items = [];   
        for (let i =  0; i < length; i++)
        {
            items.push(<option key={i + 1} value={i + 1}>{i + 1}</option>);
        }
        return items;
    };
    const onOptionChange = (e:React.ChangeEvent<HTMLSelectElement>) =>
    {
        const gotoPage = parseInt(e.target.value) - 1;
        updatePaginate(gotoPage); 
        props.updatePagination(gotoPage);
    };
   
    const checkPages = () =>
    {
        const items:any = [];
        const allPages = getPages();   
        const options = getOption(allPages.length);
        
        if (paginate < 9)
        {
            allPages.filter((e, i) => i < 9).map(e => items.push(e));
            items.push(getSelect(allPages.length - 2, options));
            items.push(getItem(allPages.length - 1));    
        }
        else if (paginate > allPages.length - 10)
        {
            items.push(getItem(0));    
            items.push(getSelect(2, options));
            allPages.filter((e, i) => i > allPages.length - 10).map(e => items.push(e));
        }
        else
        {
            items.push(getItem(0));    
            items.push(getSelect(2, options));

            allPages.filter((e, i) => i > paginate - 4 && i < paginate + 4).map(e => items.push(e));
            
            items.push(getSelect(allPages.length - 1, options));
            items.push(getItem(allPages.length - 1));    
        }

        return items;
    };

    const getSelect = (id: number, options:any) =>
    {
        return  (
        <LiSelectStyle key={"select" + id}>
            <select onChange={onOptionChange}>
                {options}
            </select>
            <Icon iconName="ScrollUpDown" />
        </LiSelectStyle>
        );
    };

    return (
        <PaginateStyle>
            <Icon iconName="ChevronLeft" onClick={setPagination("prev")}/>
            <ul>
                {pages < 11 ? getPages() : checkPages()}               
            </ul>
            <Icon iconName="ChevronRight" onClick={setPagination("next")}/>
        </PaginateStyle>
    );

};

export default Paginate;


// WEBPACK FOOTER //
// ./src/components/product/productList/Paginate.tsx